
export const getYearsOptions = (count, reverse) => {
  const year = new Date().getFullYear() 
  const min = reverse ? year - count : year
  const max = reverse ? year : year + count
  const years = []
  for (var i = min; i <= max; i++) {
    years.push(<option key={i}>{i}</option>)
  }
  return reverse ? years.reverse() : years
}

export const getOrganizationOptions = (orgArray) => orgArray.map(org => <option key={org.idOrganization} value={org.idOrganization}>{org.OrgName}</option>) 

export const getOptions = (array) => {
    const _array = array || []
    return _array.map(item => {
        const value = item.id || item.value
        return <option key={value} value={value}>{item.name}</option>
    })
}

export const getCertificationPeriodsOptions = (periods) => {
    const _periods = periods || []
    return _periods.map(period => {
        const dateFrom = new Date(period.date_from).toLocaleDateString('ru-RU')
        const dateTo = new Date(period.date_to).toLocaleDateString('ru-RU')
        const title = `${dateFrom} - ${dateTo}`
        return <option key={period.id} value={period.id}>{title}</option>
    })
}

export const getCertificationPeriodsOptionsForTeacher = (periods) => {
  const _periods = periods || []
  return _periods.map(period => {
      const dateFromObj = new Date(period.date_from)
      const dateToObj = new Date(period.date_to)
      const dateFrom = dateFromObj.toLocaleDateString('ru-RU')
      const dateTo = dateToObj.toLocaleDateString('ru-RU')
      const title = `${dateFrom} - ${dateTo}`
      const disabled = dateFromObj < new Date()
      return <option key={period.id} value={period.id} disabled={disabled}>{title}</option>
  })
}